export default "__VITE_ASSET__BUWzvc75__"